import React, { useState, useEffect, useRef } from 'react'
import './Document.css'
import PropTypes from 'prop-types'
import DocumentRow from './DocumentRow'
import SignerModal from '../profile/SignerModal'
import Spinner from '../../utilities/spinner/Spinner'
import { searchTable, useSortableData, getClassNamesFor } from '../../utilities/tableTools/tableTools'
// Bootstrap
import Button from 'react-bootstrap/Button'
//Redux
import { getDirectProfile, getDocuments } from '../../redux'
import { useDispatch, useSelector } from 'react-redux'

function DocumentTable(props) {
  const { type } = props

  const [myDocuments, setMyDocuments] = useState(null)
  const [column, setColumn] = useState(1)
  const [show, setShow] = useState(false)

  const myRef = useRef()
  const dispatch = useDispatch()
  const document = useSelector((state) => state.document)
  const user = useSelector((state) => state.user)
  const overview = useSelector((state) => state.overview)

  const { items, requestSort, sortConfig } = useSortableData(myDocuments)

  const handleModalClose = () => setShow(false)
  const isReceiver = (receiver) => receiver.id === user.credentials.id

  useEffect(() => {
    if (type !== 'Pending' && type !== 'All') dispatch(getDocuments(type, 10, false))
  }, [])

  useEffect(() => {
    if (document.documents) {
      let filteredDocuments
      switch (type) {
        case 'Completed':
        case 'Pending':
        case 'Rejected':
        case 'Expired':
          filteredDocuments = document.documents.filter((document) => document.status === type)
          break
        default:
          filteredDocuments = document.documents
      }
      switch (overview.dropdownOption) {
        case 2:
          setMyDocuments(filteredDocuments.filter((doc) => doc.receivers.some(isReceiver)))
          break
        case 3:
          setMyDocuments(filteredDocuments.filter((doc) => doc.sender.id === user.credentials.id))
          break
        default:
          setMyDocuments(filteredDocuments)
      }
    }
  }, [document.documents, document.refresh, overview.dropdownOption])

  const setSigner = (signerId) => {
    dispatch(getDirectProfile(signerId, setShow))
  }

  const handleLoad = () => {
    if (type === 'All') {
      // dispatch(getDocuments('Pending'))
      dispatch(getDocuments('Completed', 5))
      dispatch(getDocuments('Expired', 5))
      dispatch(getDocuments('Rejected', 5))
    } else {
      dispatch(getDocuments(type, 10))
    }
  }

  let tableContainerMarkup =
    myDocuments && myDocuments.length > 0 ? (
      <div className='table-container'>
        <div className='filter-container'>
          <select onChange={(e) => setColumn(e.target.value)} className='filter-option'>
            <option value='1'>Title</option>
            <option value='2'>Created At</option>
            <option value='3'>Due Date</option>
            <option value='5'>To Signer</option>
          </select>
          <input
            type='text'
            id='filter'
            placeholder='Filter..'
            onKeyUp={(e) => searchTable(e.target.value, myRef, column)}
            className='filter-input '
          />
        </div>
        <div className='primaryTb'>
          <table className='table-style' ref={myRef}>
            <thead>
              <tr>
                <th className='head-no'>No</th>
                <th className={`head-title ${getClassNamesFor('title', sortConfig)}`} onClick={() => requestSort('title')}>
                  Title
                </th>
                <th
                  className={`head-created ${getClassNamesFor('createdAt', sortConfig)}`}
                  onClick={() => requestSort('createdAt')}
                >
                  Created At
                </th>
                <th className={`head-duedate ${getClassNamesFor('dueDate', sortConfig)}`} onClick={() => requestSort('dueDate')}>
                  Due Date
                </th>
                {type === 'all' ? (
                  <th className={`head-status ${getClassNamesFor('status', sortConfig)}`} onClick={() => requestSort('status')}>
                    Status
                  </th>
                ) : (
                  <th className={`head-status ${getClassNamesFor('name', sortConfig)}`}>Status</th>
                )}
                <th className={`head-to ${getClassNamesFor('receivers', sortConfig)}`} onClick={() => requestSort('receivers')}>
                  To Signer
                </th>
              </tr>
            </thead>
            <tbody>
              {items.map((document, index) => {
                return <DocumentRow key={index} document={document} index={index} type={type} setSigner={setSigner} />
              })}
            </tbody>
          </table>
        </div>

        <SignerModal show={show} handleClose={handleModalClose} />
      </div>
    ) : (
      <>
        <p>No {type} documents found.</p>
      </>
    )

  let buttonMarkup =
    type !== 'Pending' ? (
      type === 'All' ? (
        document.lastVisibleDocument.Completed.isRear &&
        document.lastVisibleDocument.Expired.isRear &&
        document.lastVisibleDocument.Rejected.isRear ? (
          <p>--The line ended here--</p>
        ) : (
          <Button variant='secondary' onClick={handleLoad}>
            Load More
          </Button>
        )
      ) : document.lastVisibleDocument[type].isRear ? (
        <p>--The line ended here--</p>
      ) : (
        <Button variant='secondary' onClick={handleLoad}>
          Load More
        </Button>
      )
    ) : null

  let documentTableMarkup = myDocuments ? (
    <>
      {tableContainerMarkup}
      <div className='end_line'>{type !== 'Pending' ? buttonMarkup : <p>--The line ended here--</p>}</div>
    </>
  ) : (
    <Spinner />
  )

  return documentTableMarkup
}

DocumentTable.propTypes = {
  documents: PropTypes.arrayOf(PropTypes.object),
  type: PropTypes.string.isRequired,
}

export default DocumentTable
